import { Route, Routes } from "react-router-dom"
import { CalendarProvider } from "../provider"
import Calendar from "../pages/main"
import Detail from "../pages/detail"
import RecurrenceAlert from "../pages/recurrenceAlert"
import Form from "../../actionPlans/pages/form"
import { ReportFolioDetailProvider } from "../../reportFolio/pages/dashboard/pages/detail/provider"
import { Main } from "../../reportFolio/pages/dashboard/pages/main"
import { EditSerie } from "../pages/editSerie"

const CalendarRoutes = () => {
    return (
        <CalendarProvider>
            <Routes>
                <Route path="/" element={<Calendar />} />
                <Route path="detail/:id" element={<Detail />} />
                <Route path="edit/:id" element={<EditSerie />} />
                <Route path="recurrence/:id" element={<RecurrenceAlert />} />
                <Route path="action-plan/:id" element={<Form />} />
                <Route path="report-folio/:id" element={<ReportFolioDetailProvider />} />
                <Route path="report-folio-list/" element={<Main />} />
            </Routes>
        </CalendarProvider>
    )
}

export { CalendarRoutes }